import { Flex, IconButton, type IconProps } from '@grammarly/design-system'

import styles from './ChatButton.module.scss'
import { ArrowUpIcon } from '../icons/ArrowUpIcon'
import { StopIcon } from '../icons/StopIcon'

type ChatButtonProps = {
  readonly hasValue: boolean
  readonly isProcessing: boolean
  readonly onStop: () => void
  readonly onSubmit: () => void
}

/**
 * Chat button component
 * @param props - The component props
 * @returns The chat button component
 */
export function ChatButton(props: ChatButtonProps) {
  const { hasValue, isProcessing, onStop, onSubmit } = props

  const iconButtonProps = isProcessing
    ? {
        icon: StopIcon as unknown as IconProps['icon'],
        accessibilityLabel: 'Stop generating',
        onClick: onStop,
        variant: 'tertiary' as const,
      }
    : {
        icon: ArrowUpIcon as unknown as IconProps['icon'],
        accessibilityLabel: 'Send message',
        onClick: onSubmit,
        isDisabled: !hasValue,
        className: !hasValue ? styles.disabled : undefined,
      }

  return (
    <Flex direction="row" justify="end" align="end" marginTop="auto">
      <IconButton size="small" {...iconButtonProps} />
    </Flex>
  )
}
